import { render, staticRenderFns } from "./ExportDocx.vue?vue&type=template&id=5c8472bc&scoped=true&"
import script from "./ExportDocx.vue?vue&type=script&lang=js&"
export * from "./ExportDocx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8472bc",
  null
  
)

export default component.exports